import {pollMakeTextEditableLayersStatus} from '@Components/ai-chat-window/lib/make-text-editable.library';
import {loadPosterVersionFromHashedId} from '@PosterWhiteboard/poster/poster-init';
import {openMakeTextEditableLoadingModal} from '@Modals/make-text-editable-loading-modal';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {setIsEditableTextLayersGenerating, setPosterOverlayLoaderVisibility} from '@Components/poster-editor/poster-editor-reducer';
import {GROWL_TYPE, showMessageGrowl} from '@Components/message-growl';

const DESIGN_READY_GROWL_INTERVAL_MS = 3000;

/**
 * Editor-tab orchestration for the desktop "Editable layers" flow: opens the loading modal + overlay,
 * polls until the layered poster is ready, reloads it in place, then growls the outcome. Lives in the UI
 * layer (not poster-whiteboard) so it can drive modals/growls directly; poster-init triggers it through
 * the poster-ui port when a loaded poster carries a pending layers job id.
 */
export const runPendingLayersFlow = async (jobId: string): Promise<void> => {
  window.PMW.redux.store.dispatch(setIsEditableTextLayersGenerating(true));
  window.PMW.redux.store.dispatch(setPosterOverlayLoaderVisibility(true));
  openMakeTextEditableLoadingModal();

  let succeeded = false;
  try {
    const result = await pollMakeTextEditableLayersStatus(jobId);
    await loadPosterVersionFromHashedId(result.posterHashedId, undefined, false);
    succeeded = true;
  } catch (e: unknown) {
    console.error(e);
    showMessageGrowl({
      key: 'pending-layers-error',
      text: window.i18next.t('pmwjs_something_went_wrong'),
      type: GROWL_TYPE.DANGER,
      showCloseIcon: true,
      sticky: true,
    });
  } finally {
    window.PMW.redux.store.dispatch(closeModal(MODALS_IDS.MAKE_TEXT_EDITABLE_LOADING_MODAL));
    window.PMW.redux.store.dispatch(setPosterOverlayLoaderVisibility(false));
    window.PMW.redux.store.dispatch(setIsEditableTextLayersGenerating(false));
    if (succeeded) {
      showMessageGrowl({
        key: 'make-text-editable-design-ready',
        type: GROWL_TYPE.NEUTRAL,
        icon: 'icon-prints-stack',
        text: window.i18next.t('pmwjs_mte_design_can_now_be_edited'),
        interval: DESIGN_READY_GROWL_INTERVAL_MS,
        showCloseIcon: true,
      });
    }
  }
};
